import Toggle from "../classes/toggle";

export default class CardsTeam {
    static init() {
        return new CardsTeam();
    }

    constructor() {
        const teamCards = document.querySelectorAll('.cards-team .card-team.collapsed');
        if (teamCards.length === 0) return;

        teamCards.forEach((teamCard) => {
            const button = teamCard.querySelector('a.show-more-info');

            if (teamCard.querySelector('.card-layout').scrollHeight < 500) {
                teamCard.querySelector('.overlay').classList.add('hidden');
                teamCard.querySelector('.bard').style.marginBottom = 0;
                return;
            }

            const toggleButton = new Toggle(button, () => {
                teamCard.classList.toggle('collapsed');
            });
        });
    }
}
